import React, { Component } from "react";
import { Image, Table } from "semantic-ui-react";
import _ from "lodash";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
import Check from "../../assets/images/check.gif";
import Cross from "../../assets/images/xred.gif";
import "../../assets/styles/bootstrap-table-extra.css";
import settings from "../../settings";

function padding(val) {
  return val > 9 ? val : `0${val}`;
}

class Activities extends Component {
  getRepType = (days) => {
    switch (days) {
      case 0:
        return "Today";
      case 7:
        return "Last7Days";
      default:
        return "OlderHistory";
    }
  };

  getCsvFileName = (props) =>
    `${settings.appName}_${this.getRepType(props.days)}_${
      props.pickedUser ? props.pickedUser : props.user.userid
    }_${this.displayDate(new Date())}.csv`;

  redirectToLink = (actId, actReportId, criteria, actCode) => {
    localStorage.historyReportId = actReportId;
    localStorage.historyCriteria = criteria;
    localStorage.xmlId = actId;
    localStorage.days = this.props.days;
    localStorage.actCode = actCode;
    this.props.history.push("/search/history");
  };

  displayDate = (d) =>
    `${[padding(d.getMonth() + 1), padding(d.getDate()), d.getFullYear()].join(
      "/"
    )} ${[
      padding(d.getHours() > 12 ? d.getHours() - 12 : d.getHours()),
      padding(d.getMinutes()),
      padding(d.getSeconds()),
    ].join(":")} ${d.getHours() > 12 ? "PM" : "AM"}`;

  activityLink = (cell, row) => {
    const {
      actId,
      actReportId,
      actType,
      actCode,
      reportCategory,
      activityDescription,
      showLink,
    } = row;
    const displayActivityDescription = activityDescription.indexOf("searchID")
      ? activityDescription.split("_")[0]
      : activityDescription;
    const { days } = this.props;
    if (
      actReportId === "17" ||
      actReportId === "20" ||
      actReportId === "84" ||
      activityDescription.indexOf("Loading") > -1 ||
      actType === "ao" ||
      !showLink
    )
      return displayActivityDescription;
    if (
      (days === 0 || days === 7) &&
      (reportCategory === "Report" || actCode !== "0" || actReportId === "139")
    ) {
      return (
        <span
          role="button"
          tabIndex={0}
          className={"url-link-activity"}
          onClick={() =>
            this.redirectToLink(
              actId,
              actReportId,
              activityDescription,
              actCode
            )
          }
        >
          {displayActivityDescription}
        </span>
      );
    }

    if (
      reportCategory !== "Report" // &&
      // actCode !== "0" &&
      // actReportId === "139"
    ) {
      return (
        <span
          role="button"
          tabIndex={0}
          className={"url-link-activity"}
          onClick={() =>
            this.redirectToLink(
              actId,
              actReportId,
              activityDescription,
              actCode
            )
          }
        >
          {displayActivityDescription}
        </span>
      );
    }
    return displayActivityDescription;
  };

  activityFormat = (cell, row) => (
    <span className={"icon-align-middle"}>
      {row.actCode[0] > 0 ? (
        <Image src={Check} inline className={"icon-align-middle"} />
      ) : (
        <Image src={Cross} inline className={"icon-align-middle"} />
      )}
      {row.reportCategory !== "Report" ? `${row.reportTypeName} : ` : ""}
      {row.reportLabel}
    </span>
  );

  options = {
    sortName: "reportLabel",
    sortOrder: "desc",
  };

  render() {
    const reports = _.get(
      this.props.data,
      "searchMenu[0].soap:Envelope[0].soap:Body[0].GetUserSearchListExResponse[0].GetUserSearchListExResult[0].UserItems[0].Reports[0]"
    );
    const reps = [];
    const rows = [];
    let isAdminUser = false;
    if (reports !== undefined) {
      _.forEach(reports.row, (rep) => {
        reps[rep.ReportID[0]] = rep;
      });
      const activities = _.get(this.props.data, "activity");
      if (activities && activities.length > 0) {
        isAdminUser = activities[0].acctMasterUser[0] === "1";
      }
      _.forEach(activities, (element) => {
        let showLink = false;
        if (!this.props.noLinks && reps[element.actReportID] 
          && (!element.actCode[0] || element.actCode[0] !== "0") ) {
          showLink = true;
        }
        const cols = {
          actId: element.actId[0],
          actCode: element.actCode[0],
          actType: element.actType[0],
          reportCategory: element.reportCategory[0],
          reportTypeName: element.reportTypeName[0],
          reportLabel: element.reportLabel[0],
          activityDescription: element.actDesc[0],
          activityCost: element.actCost[0],
          actReportId: element.actReportID[0],
          acctUserCode: element.acctUserCode[0],
          acctMasterUser: element.acctMasterUser[0],
          showLink,
          found: `${
            element.reportCategory[0] === "Search" && element.actCode[0] !== 0
              ? `${element.actCode[0]} rec${element.actCode[0] > 1 ? "s" : ""}`
              : ""
          }`,
          activityDate: new Date(Date.parse(element.actUpdateFormatted[0])),
        };
        rows.push(cols);
      });
    }

    const columns = [
      {
        dataField: "reportLabel",
        text: "Activity",
        formatter: this.activityFormat,
        width: "15%",
        sort: true,
      },
      {
        dataField: "activityDescription",
        text: "Desciption",
        formatter: this.activityLink,
        width: "40%",
        sort: true,
      },
      {
        dataField: "found",
        text: "Found",
        width: "10%",
        sort: true,
      },
      {
        dataField: "activityDate",
        text: "Date",
        width: "15%",
        formatter: this.displayDate,
        csvFormatter: this.displayDate,
        sort: true,
      },
    ];
    const adminColumns = [
      {
        dataField: "acctUserCode",
        text: "User",
        width: "15%",
        sort: true,
      },
      {
        dataField: "reportLabel",
        text: "Activity",
        formatter: this.activityFormat,
        width: "15%",
        sort: true,
      },
      {
        dataField: "activityDescription",
        text: "Desciption",
        formatter: this.activityLink,
        width: "30%",
        sort: true,
      },
      {
        dataField: "found",
        text: "Found",
        width: "5%",
        sort: true,
      },
      {
        dataField: "activityDate",
        text: "Date",
        width: "15%",
        formatter: this.displayDate,
        csvFormatter: this.displayDate,
        sort: true,
      },
    ];
    const { SearchBar } = Search;
    const { ExportCSVButton } = CSVExport;
    return (
      <ToolkitProvider
        keyField={"actId"}
        data={rows}
        columns={isAdminUser ? adminColumns : columns}
        exportCSV={{
          fileName: this.getCsvFileName(this.props),
          onlyExportFiltered: true,
          exportAll: false,
        }}
        search
      >
        {(props) => (
          <div className={"padding-top-10"}>
            <Table className={"table-no-border-and-padding medium-font"}>
              <Table.Body>
                <Table.Row>
                  <Table.Cell>
                    <span className={"padding-right-10"}>
                      Filter Activities:
                    </span>{" "}
                    <SearchBar {...props.searchProps} />
                  </Table.Cell>
                  <Table.Cell className={"float-right"}>
                    <ExportCSVButton {...props.csvProps}>
                      Export CSV
                    </ExportCSVButton>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
            <BootstrapTable
              className={"padding-top-10 medium-font"}
              keyField={"actId"}
              hover
              striped
              pagination={paginationFactory()}
              {...props.baseProps}
            />
          </div>
        )}
      </ToolkitProvider>
    );
  }
}

export default Activities;



// WEBPACK FOOTER //
// ./src/components/myaccount/Activities.js